import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import Tag from 'primevue/tag';

import { useNetworkStatus } from '../composables/useNetworkStatus';


export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkStatus',
  setup(__props) {

const { isOnline } = useNetworkStatus();

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_unref(isOnline))
    ? _withDirectives((_openBlock(), _createBlock(_unref(Tag), {
        key: 0,
        severity: "success",
        value: "Online",
        rounded: ""
      }, null, 512)), [
        [_directive_auto_animate]
      ])
    : _withDirectives((_openBlock(), _createBlock(_unref(Tag), {
        key: 1,
        severity: "danger",
        value: "Offline",
        rounded: ""
      }, null, 512)), [
        [_directive_auto_animate]
      ])
}
}

})